<template>
  <div class="text-end mb-3">
    <button
      class="btn btn-primary"
      title="Exportar para Excel"
      @click="exportToExcel"
    >
      Exportar para Excel
    </button>
  </div>
  <div class="card">
    <div class="table-responsive">
      <table class="table table-sm table-bordered" id="tableReport">
        <thead class="bg-dark text-white text-center">
          <tr>
            <th colspan="5">Item</th>
            <th>Proposto</th>
            <th>Reformulado</th>
            <th>Variação (P-R)/R</th>
          </tr>
        </thead>
        <tbody>
          <template
            v-for="codigoOrcamentario in reports.codigosOrcamentarios"
            :key="codigoOrcamentario.codOrcamentario"
          >
            <tr
              v-if="codigoOrcamentario.valores.length > 0"
              class="bg-teal text-white"
            >
              <td>
                <strong>{{ codigoOrcamentario.codOrcamentario }}</strong>
              </td>
              <td colspan="4">
                <strong>{{ codigoOrcamentario.descricaoOrcamentario }}</strong>
              </td>
              <td class="text-center">
                <strong>
                  {{ moneyToCurrencyBr(codigoOrcamentario.total.proposta) }}
                </strong>
              </td>
              <td class="text-center">
                <strong>
                  {{ moneyToCurrencyBr(codigoOrcamentario.total.reformulacao) }}
                </strong>
              </td>
              <td class="text-center">
                <strong>
                  {{
                    moneyToCurrencyBrNoSymbol(
                      codigoOrcamentario.total.variacao,
                    )
                  }}%
                </strong>
              </td>
            </tr>
            <template
              v-for="(valor, index) in codigoOrcamentario.valores"
              :key="index"
            >
              <tr class="table-success">
                <td></td>
                <td colspan="4">{{ valor.tipo }}</td>
                <td class="text-center">
                  {{ moneyToCurrencyBr(valor.total.proposta) }}
                </td>
                <td class="text-center">
                  {{ moneyToCurrencyBr(valor.total.reformulacao) }}
                </td>
                <td class="text-center">
                  {{ moneyToCurrencyBrNoSymbol(valor.total.variacao) }}%
                </td>
              </tr>
              <template v-for="(recurso, index) in valor.recursos" :key="index">
                <tr class="table-active">
                  <td></td>
                  <td></td>
                  <td colspan="3">{{ recurso.tipo }}</td>
                  <td class="text-center">
                    {{ moneyToCurrencyBr(recurso.total.proposta) }}
                  </td>
                  <td class="text-center">
                    {{ moneyToCurrencyBr(recurso.total.reformulacao) }}
                  </td>
                  <td class="text-center">
                    {{ moneyToCurrencyBrNoSymbol(recurso.total.variacao) }}%
                  </td>
                </tr>
                <template
                  v-for="(natureza, index) in recurso.naturezas"
                  :key="index"
                >
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{{ natureza.codTBOrcamento }}</td>
                    <td>{{ natureza.descricao }}</td>
                    <td class="text-center">
                      {{ moneyToCurrencyBr(natureza.proposta) }}
                    </td>
                    <td class="text-center">
                      {{ moneyToCurrencyBr(natureza.reformulacao) }}
                    </td>
                    <td class="text-center">
                      {{ moneyToCurrencyBrNoSymbol(natureza.variacao) }}%
                    </td>
                  </tr>
                </template>
              </template>
            </template>
          </template>
          <tr class="table-primary">
            <td colspan="5"><strong>Total de Recursos Próprios</strong></td>
            <td class="text-center">
              <strong>
                {{
                  moneyToCurrencyBr(reports.totais.recursosProprios.proposta)
                }}
              </strong>
            </td>
            <td class="text-center">
              <strong>
                {{
                  moneyToCurrencyBr(
                    reports.totais.recursosProprios.reformulacao,
                  )
                }}
              </strong>
            </td>
            <td class="text-center">
              <strong>
                {{
                  moneyToCurrencyBrNoSymbol(
                    reports.totais.recursosProprios.variacao,
                  )
                }}%
              </strong>
            </td>
          </tr>
          <tr class="table-primary">
            <td colspan="5">
              <strong>Total de Recursos de Terceiros</strong>
            </td>
            <td class="text-center">
              <strong>
                {{
                  moneyToCurrencyBr(reports.totais.recursosTerceiros.proposta)
                }}
              </strong>
            </td>
            <td class="text-center">
              <strong>
                {{
                  moneyToCurrencyBr(
                    reports.totais.recursosTerceiros.reformulacao,
                  )
                }}
              </strong>
            </td>
            <td class="text-center">
              <strong>
                {{
                  moneyToCurrencyBrNoSymbol(
                    reports.totais.recursosTerceiros.variacao,
                  )
                }}%
              </strong>
            </td>
          </tr>
          <tr class="table-success">
            <td colspan="5"><strong>Total Geral</strong></td>
            <td class="text-center">
              <strong>
                {{ moneyToCurrencyBr(reports.totais.total.proposta) }}
              </strong>
            </td>
            <td class="text-center">
              <strong>
                {{ moneyToCurrencyBr(reports.totais.total.reformulacao) }}
              </strong>
            </td>
            <td class="text-center">
              <strong>
                {{ moneyToCurrencyBrNoSymbol(reports.totais.total.variacao) }}%
              </strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { moneyToCurrencyBr, moneyToCurrencyBrNoSymbol } from '@/utils/strings'
import '@/assets/js/jquery.table2excel'

export default {
  name: 'OrcamentarioComparativoResult',

  props: {
    reports: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      moneyToCurrencyBr,
      moneyToCurrencyBrNoSymbol,
    }
  },

  methods: {
    exportToExcel() {
      window.$('#tableReport').table2excel({
        name: 'Orcamentario Comparativo',
        filename: 'Relatorio_SGCC_Orcamentario_Comparativo.xls',
      })
    },
  },
}
</script>

<style scoped>
td {
  padding: 0.3rem;
}
</style>
